import React from 'react';
import cn from 'classnames';
import _upperFirst from 'lodash/upperFirst';

import { STATUS_ICON, STATUS_TEXT } from 'constants/common';

import { idxMap } from 'helpers/styleMapIdx';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import { Popover } from 'components/Popover';
import { ContextMenu } from 'components/ContextMenu';

import styles from './StatusSelect.module.scss';

const SIZES = {
  sm: styles.sm,
  lg: styles.lg,
};

const StatusSelect = ({
  className,
  contextItems,
  status,
  size,
  onContextItemClick,
}: {
  className: any;
  contextItems: any;
  status: any;
  size: any;
  onContextItemClick: any;
}) => (
  <Popover
    placement="bottom-end"
    triggerElement={({ isMounted }: { isMounted: any }) => (
      <div
        className={cn(
          styles.status,
          styles[`status${_upperFirst(status)}`],
          idxMap(SIZES as Record<string, string>, size),
          {
            [styles.statusActive]: isMounted,
          },
          className,
        )}
      >
        <Icon
          className={styles.icon}
          name={idxMap(STATUS_ICON as Record<string, string>, status)}
        />
        <Typography
          className={styles.text}
          variant="body3"
          weight="medium"
          mode="compact"
        >
          {idxMap(STATUS_TEXT as Record<string, string>, status)}
        </Typography>
        <Icon className={styles.dropdownIcon} name="chevronDown" />
      </div>
    )}
  >
    <ContextMenu
      className={styles.menu}
      items={contextItems}
      onItemClick={(contextItem: any) => onContextItemClick(contextItem)}
    />
  </Popover>
);

StatusSelect.defaultProps = {
  size: 'lg',
};

export default React.memo(StatusSelect) as any;
